import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ad76919"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-card" }
const _hoisted_2 = { class: "step-index" }
const _hoisted_3 = { class: "box-img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "step-name" }
const _hoisted_6 = { class: "step-desc" }

interface IProps {
    index: number;
    icon: string;
    title: string;
    description: string;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    index: null,
    icon: null,
    title: null,
    description: null
  },
  setup(__props: any) {

  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Step." + _toDisplayString(__props.index), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", { src: __props.icon }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_6, _toDisplayString(__props.description), 1)
  ]))
}
}

})